<template>
  <button class="create-project-btn" type="submit" @click="click()">
    <slot>Create Project</slot>
  </button>
</template>

<script>
import Project from '../../lib/projects/ProjectModel';

export default {
  name: 'CreateProject',
  props: {
    project: {
      type: Project,
      default: () => {},
    },
  },
  methods: {
    async click() {
      try {
        if (this.project.id) {
          const project = await this.$pigeonline.projects.update(this.project);
          this.$emit('projectCreated', project);
        } else {
          const project = await this.$pigeonline.projects.create(this.project);
          this.$emit('projectCreated', project);
        }
      } catch (e) {
        //console.error(e);
        this.$emit('projectCreationError');
      }
    },
  },
};
</script>
